import { Body2, RadioButtonItem } from '@tumelo/designsystem'
import React from 'react'
import { Scheme } from '../../proto/tumelo/stewardshipbff/v1/scheme'

interface SchemeRadioButtonsProps {
  schemes: Scheme[]
  selectedSchemeName: string
  onSchemeChange: (schemeName: string) => void
}

export const SchemeRadioButtons: React.FC<SchemeRadioButtonsProps> = ({
  schemes,
  selectedSchemeName,
  onSchemeChange,
}) => {
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSchemeChange(e.target.value)
  }

  return (
    <>
      {schemes.map(({ title, name }) => {
        const isSelected = name === selectedSchemeName
        return (
          <RadioButtonItem value={name} key={name} onChange={handleRadioChange} checked={isSelected}>
            <Body2 mb="0">{title}</Body2>
          </RadioButtonItem>
        )
      })}
    </>
  )
}
